export const validation = () => {

  const password = document.querySelector('#registrationPassword');
  const passwordRepeat = document.querySelector('#registrationPasswordRepeat');

  if ( password && passwordRepeat ) {

    password.oninput = function() {

      if ( passwordRepeat.value == password.value  ) {
        console.log("match");
        passwordRepeat.setCustomValidity("");
      } else {
        passwordRepeat.setCustomValidity("Пароли не совпадают");
      }

    }

    passwordRepeat.oninput = function() {

      if ( passwordRepeat.value == password.value  ) {
        console.log("match");
        passwordRepeat.setCustomValidity("");
      } else {
        passwordRepeat.setCustomValidity("Пароли не совпадают");
      }

    }

  }

}